import { Layout, List, Tabs } from "antd";
import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import "./App.less";
import HTTPSpeedItem from "./components/HTTPSpeedItem";
import OperationGuide from "./components/OperationGuide";
import RPCSpeedItem from "./components/RPCSpeedItem";
import TheGraphSpeedItem from "./components/TheGraphSpeedItem";
import UserHeader from "./components/UserHeader";
import bscUrls from "./data/bsc.json";
import devUrls from "./data/dev.json";
import ethUrls from "./data/eth.json";
import hecoUrls from "./data/heco.json";
import { Language, SpeedItemData } from "./types/types";

const urlsMap = {
  eth: ethUrls as SpeedItemData[],
  bsc: bscUrls as SpeedItemData[],
  heco: hecoUrls as SpeedItemData[],
  dev: devUrls as SpeedItemData[],
};

const { Content, Footer } = Layout;
const { TabPane } = Tabs;
interface AppProps {
  isDev?: boolean;
}

export const GlobalContext = React.createContext<{
  language: Language;
  setLanguage: (lang: Language) => void;
}>({ language: "zh-CN", setLanguage: () => {} });

const languageMap: Record<string, Language> = {
  "en-US": "en-US",
  "zh-CN": "zh-CN",
};

const doctorImgStyle: React.CSSProperties = {
  position: "absolute",
  right: 90,
  top: -86,
  height: 118,
  width: 160,
  backgroundImage: "url('/images/DODO doctor.png')",
  backgroundSize: "cover",
  backgroundPosition: "top center",
};

const DEFAULT_LANGUAGE = "zh-CN";

const App = (props: AppProps) => {
  const [language, setLanguage] = useState<Language>(() => {
    const lang = localStorage.getItem("lang");
    return (lang && languageMap[lang]) || DEFAULT_LANGUAGE;
  });

  const { isDev } = props;
  console.log(props);
  const his = useHistory();
  const path = his.location.pathname.replace("/", "");
  const renderTabPane = useCallback(
    (keyName: "eth" | "bsc" | "heco" | "dev") => {
      const url = urlsMap[keyName] as SpeedItemData[];
      return (
        <TabPane tab={keyName.toUpperCase()} key={keyName}>
          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 1,
              md: 3,
              lg: 3,
              xl: 3,
              xxl: 3,
            }}
            itemLayout="horizontal"
            dataSource={url}
            renderItem={(item) => {
              var renderItem: React.ReactNode;
              switch (item.type) {
                case "http":
                  renderItem = <HTTPSpeedItem item={item} />;
                  break;
                case "rpc":
                  renderItem = <RPCSpeedItem item={item} />;
                  break;
                case "thegraph":
                  renderItem = <TheGraphSpeedItem item={item} />;
                  break;
              }
              return renderItem;
            }}
          />
        </TabPane>
      );
    },
    []
  );

  const renderDocPane = useCallback(() => {
    return (
      <>
        {renderTabPane("eth")}
        {renderTabPane("bsc")}
        {/* {renderTabPane("heco")} */}
      </>
    );
  }, [renderTabPane]);

  const renderDevPanel = useCallback(() => {
    return <>{renderTabPane("dev")}</>;
  }, [renderTabPane]);

  console.log("renderDevPanel", isDev);

  return (
    <GlobalContext.Provider value={{ language, setLanguage }}>
      <Layout
        style={{
          margin: "0 auto",
          maxWidth: 1340,
          padding: "0 20px",
        }}
      >
        <UserHeader />
        <OperationGuide />
        <Content>
          <div style={{ flex: 1, position: "relative" }} className="content">
            <div style={doctorImgStyle} className="docter-img" />
            <Tabs
              animated={false}
              defaultActiveKey={path}
              onChange={(activeKey) => {
                his.push("/" + activeKey);
                his.go(0);
              }}
            >
              {isDev ? renderDevPanel() : renderDocPane()}
            </Tabs>
          </div>
        </Content>
        <Footer
          style={{
            textAlign: "center",
            background: "transparent",
            color: "#85858D",
            padding: "30px 0 40px 0",
          }}
        >
          ©2021 Created by DODO Labs
        </Footer>
      </Layout>
    </GlobalContext.Provider>
  );
};

export default App;
